module.exports = __webpack_public_path__ + "img/banner1-old.bd05c183.jpeg";